import { Component, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, Input } from "@angular/core";

import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { UntypedFormGroup, Validators, UntypedFormControl } from "@angular/forms";
import { Customer, CustomerAddress, CustomerContactNumber, GenderEnum, PersonalityKindEnum } from "src/app/frontoffice/parties/model/customer.model";
import { takeUntil } from "rxjs/operators";
import { LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { NumberType, RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { CustomerCategory } from "src/app/frontoffice/parties/model/customer-categories.model";
import { Zone } from "src/app/frontoffice/parties/model/zone.model";
import { CustomerNumberOrderComponent } from "../customernumberorder/customernumberorder.component";
import { CustomerAddressOrderComponent } from "../customeraddressorder/customeraddressorder.component";

import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { CustomerOrderService } from "../customerorder.service";

@Component({
  selector: "order-newcustomer",
  templateUrl: "./newcustomerorder.component.html",
  styleUrls: ["./newcustomerorder.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewCustomerOrderComponent extends BaseListComponent {
  // @Output() onStateChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRefresh: EventEmitter<any> = new EventEmitter<any>();
  @Input() customerOrder: CustomerOrderService;
  customer: Customer;
  lookup: any;
  gender: Lookup[];
  customerCategory: CustomerCategory[];
  personalityKind: Lookup[];
  zone: Zone[];
  numbersVisibility: boolean;
  Model: any;

  constructor(private lookupService: LookupService, public dialog: SimpleModalService, protected cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.apiName = "Customer";
    this.fillData();
  }

  protected getDataFromFormGroup() {
    Object.keys(this.group.controls).forEach((key) => {
      this.customer[key] = this.group.controls[key].value;
    });
    return this.customer;
  }

  //پر کردن اطلاعات اولیه
  fillData() {
    this.setMaxCode();
    this.group = null;
    let group: any = {};
    this.numbersVisibility = false;

    this.customer = new Customer();
    this.customer.Numbers = [];
    this.customer.Party = null;
    this.customer.Occasions = null;
    this.customer.Addresses = [];

    group["FirstName"] = new UntypedFormControl(undefined, [Validators.maxLength(200)]);
    group["LastName"] = new UntypedFormControl(undefined, [Validators.maxLength(200), Validators.required]);
    group["Number"] = new UntypedFormControl(undefined, Validators.maxLength(200));
    group["Title"] = new UntypedFormControl(undefined, Validators.maxLength(200));
    group["Gender"] = new UntypedFormControl(undefined, [Validators.maxLength(200), Validators.required]);
    group["Addresses"] = new UntypedFormControl(undefined, [Validators.maxLength(200), Validators.required]);
    group["ZoneId"] = new UntypedFormControl(undefined, [Validators.maxLength(200), Validators.required]);
    group["ShippingCost"] = new UntypedFormControl(undefined, [Validators.maxLength(200), Validators.required]);
    group["CategoryId"] = new UntypedFormControl(undefined, [Validators.maxLength(200), Validators.required]);
    group["NumberTypeId"] = new UntypedFormControl(undefined, [Validators.maxLength(200), Validators.required]);
    // group['Numbers'] = new FormControl(undefined, [Validators.maxLength(200), Validators.required]);
    group["PersonalityKindId"] = new UntypedFormControl(undefined, [Validators.maxLength(200), Validators.required]);
    this.group = new UntypedFormGroup(group);
    this.group.controls["ShippingCost"].disable();

    this.httpCommonService
      .getList("Zone/GetZones")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Zone[]) => {
        this.zone = data;
        if (this.zone && this.zone.length === 1) {
          this.group.controls["ZoneId"].setValue(this.zone[0].Id);
          this.group.controls["ShippingCost"].setValue(this.zone[0].ShippingCost);
        }
      });

    this.httpCommonService
      .getItem("CustomerCategory/GetCustomersCategory", this.customerOrder.order.saleMethodBranch.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: CustomerCategory[]) => {
        this.customerCategory = data;
        if (this.customerCategory && this.customerCategory.length === 1) this.group.controls["CategoryId"].setValue(this.customerCategory[0].Id);
      });

    this.lookupService
      .getLookupbyCategory("GNR", "PersonalityKind")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Lookup[]) => {
        this.personalityKind = data;
        const find = data.find((f) => f.Code === PersonalityKindEnum.Realperson);
        this.group.controls["PersonalityKindId"].setValue(find.Id);
      });

    this.lookupService
      .getLookupbyCategory("GNR", "Gender")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Lookup[]) => {
        this.gender = data;
        const find = data.find((f) => f.Code === GenderEnum.Male);
        this.group.controls["Gender"].setValue(find.Id);
      });
  }

  //برگشت به صفحه جزئیات مشتری
  stateChange() {
    this.customerOrder.currentCustomerDetailsEnum = this.customerOrder.customerDetailsEnum.Details;
    this.cd.markForCheck();
  }

  //تنظیم کد مشتری
  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (!this.customer) this.customer = new Customer();
        if (data) {
          this.customer.Number = data as number;
          this.group.controls["Number"].setValue(data);
        }
      });
  }

  //ثبت مشتری جدید
  submit() {
    this.group.markAllAsTouched();
    if (!this.group.controls["ZoneId"].value || !this.group.controls["Addresses"].value) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.CustomerDefaultAddressNotSelected")}`,
        this.translate("ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.ErrorMessage")
      );
      return;
    }
    if (!this.customerOrder.group.controls["Numbers"].value || !this.group.controls["NumberTypeId"].value) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.DefaultCustomerPhoneIsNotSelected")}`,
        this.translate("ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.ErrorMessage")
      );
      return;
    }
    if (this.group.invalid) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.FillInFieldsWithAsterisks")}`,
        this.translate("ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.ErrorMessage")
      );
      return;
    }
    this.customer.FirstName = this.group.controls["FirstName"].value;
    this.customer.LastName = this.group.controls["LastName"].value;
    this.customer.Number = this.group.controls["Number"].value;
    this.customer.Title = this.group.controls["Title"].value;
    this.customer.GenderId = this.group.controls["Gender"].value;
    this.customer.IsActive = true;
    this.customer.State = RowState.New;
    this.customer.Party.PersonalityKindId = this.group.controls["PersonalityKindId"].value;
    this.customer.CategoryId = this.group.controls["CategoryId"].value;

    //this.customer.NumberTypeId = this.group.controls['NumberTypeId'].value;
    this.customer.PhoneNumber = this.customerOrder.group.controls["Numbers"].value;
    this.customer.ZoneId = this.group.controls["ZoneId"].value;
    this.customer.Address = this.group.controls["Addresses"].value;
    this.customer.ShippingCost = this.zone.find((f) => f.Id === this.group.controls["ZoneId"].value)?.ShippingCost;

    const Address = new CustomerAddress();
    Address.Address = this.group.controls["Addresses"].value;
    Address.ZoneId = this.group.controls["ZoneId"].value;
    Address.ShippingCost = this.customer.ShippingCost;
    Address.IsDefault = true;
    Address.State = RowState.New;
    Address.IsDefault = true;
    this.customer.Addresses.push(Address);

    const phone = new CustomerContactNumber();
    phone.Number = this.customerOrder.group.controls["Numbers"].value;
    const numberType: Lookup = this.group.controls["NumberTypeId"].value;
    phone.NumberTypeId = numberType.Id;
    phone.IsDefault = true;
    phone.State = RowState.New;
    this.customer.Numbers.forEach((x) => {
      x.State = RowState.Modify;
      x.IsDefault = false;
    });
    this.customer.Numbers.push(phone);
    this.customer.NumberTypeId = null;
    this.httpCommonService
      .create(this.apiName, this.customer)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: number) => {
          if (data) {
            this.customerOrder.GetCustomerDetails(data, true);
            this.customerOrder.group.controls["Numbers"].setValue("");
            //this.httpCommonService.getItem("Customer", data)
            //  .pipe(takeUntil(this.ngUnsubscribe))
            //  .subscribe((customer: Customer) => {
            //    this.customerOrder.currentCustomer = customer;
            //    this.customerOrder.setCostomerInfo();
            //this.customerOrder.order.invoice.Customer = customer;
            //this.customerOrder.order.invoice.CustomerId = customer.Id;
            //this.customerOrder.order.invoice.AddressId = customer.Addresses[0].Id;
            //this.customerOrder.order.invoice.Customer.Addresses = customer.Addresses;
            //this.customerOrder.order.invoice.CustomerAddress = customer.Addresses[0];
            //this.customerOrder.order.invoice.CustomerAddres = customer.Addresses[0].Address;
            //this.customerOrder.order.invoice.PhoneId = customer.Numbers[0].Id;
            //this.customerOrder.order.invoice.Customer.Numbers = customer.Numbers;
            //this.customerOrder.order.invoice.CustomerAddres = customer.Addresses[0].Address;
            //this.customerOrder.order.invoice.PhoneNumber = customer.Numbers[0].Number;
            //this.customerOrder.order.invoice.CustomerDisplayName = customer.DisplayName;
            //this.customerOrder.order.invoice.Customer.Addresses = customer.Addresses;
            //this.customerOrder.order.invoice.CustomerName = customer.Party.FirstName;
            //this.customerOrder.order.invoice.CustomerLastName = customer.Party.LastName;
            //this.customerOrder.order.invoice.CustomerNumber=customer.Party.Number;
            //this.customerOrder.order.invoiceChanged = true;
            //this.customerOrder.order.setActivePage(ActivePageEnum.Order);
            //});
          }
          //this.fillData();
          //this.sts.showToast("success", '', "عملیات با موفقیت انجام شد");
          //this.onRefresh.emit();
        },
        (error) => {
          this.sts.showDialog(
            `${Utilities.getHttpResponseMessage(error)}`,
            this.translate("ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.ErrorMessage")
          );
        }
      );
    const findIndexOfCurrentAddress = this.customer.Addresses.findIndex((x) => x.Address === this.group.controls["Addresses"].value);
    if (!(findIndexOfCurrentAddress < 0)) {
      this.customer.Addresses.splice(findIndexOfCurrentAddress, 1);
    }
    let findIndexOfCurrentPhone = this.customer.Numbers.findIndex((x) => x.Number === this.customerOrder.group.controls["Numbers"].value);
    if (!(findIndexOfCurrentPhone < 0)) {
      this.customer.Numbers.splice(findIndexOfCurrentPhone, 1);
    }
  }

  //تنظیم کرایه با تغییر محله
  onChanged(zone: Zone) {
    this.group.controls["ShippingCost"].setValue(zone.ShippingCost);
    this.group.controls["Addresses"].setValue(zone.Title);
  }

  //انجام تنظیمات شماره تلفن با تغییر نوع شماره تلفن
  onNumberTypeChanged(data: Lookup) {
    if (!data) {
      this.numbersVisibility = false;
      this.customerOrder.group.controls["Numbers"].setValue("");
      return;
    } else {
      this.numbersVisibility = true;
      this.setPatternKey(data.Code);
    }
  }

  //نمایش پاپ آپ ایجاد شماره تلفن جدید
  ShowPhoneDialog() {
    const data = new Customer();
    data.Numbers = [];
    data.Numbers[0] = new CustomerContactNumber();
    this.dialog
      .open(
        CustomerNumberOrderComponent,
        {
          currentrow: data,
          errorMessage: "NotFound!!!",
        },
        {
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model: any) => {
        // this.Model = model;
        this.customer.Numbers.push(model[1]);
        console.log(model);
        this.cd.markForCheck();
        // if (model && model.Numbers && model.Numbers.length > 0)
        //   this.customer.Numbers.push(model.Numbers[1]);
      });
  }

  //نمایش پاپ آپ ایجاد آدرس جدید
  ShowAddressDialog() {
    const data = new CustomerAddress();
    this.dialog
      .open(CustomerAddressOrderComponent, {
        context: {
          currentrow: data,
          errorMessage: "NotFound!!!",
        },
        closeOnBackdropClick: false,
      })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model: any) => {
        if (model && model.Addresses && model.Addresses.length > 0) this.customer.Addresses.push(model.Addresses[0]);
      }),
      500;
  }

  //حذف تلفن
  DeleteSelectedPhone(phone: CustomerContactNumber) {
    if (phone) {
      let phoneFindIndex = this.customer.Numbers.findIndex((x) => x.Number == phone.Number);
      if (!(phoneFindIndex < 0)) {
        this.customer.Numbers.splice(phoneFindIndex, 1);
      }
    }
  }

  setPatternKey(Code: number) {
    let patternKey = "^[1-9]\\d{3,7}";
    if (Code === NumberType.Mobile) {
      patternKey = "^[0-0][9-9]\\d{9}";
    }
    if (this.customerOrder.group.controls["Numbers"]) {
      this.customerOrder.group.controls["Numbers"].clearValidators();
      this.customerOrder.group.controls["Numbers"].setErrors(null);
      this.customerOrder.group.controls["Numbers"].setValidators([Validators.required, Validators.pattern(patternKey)]);
      this.customerOrder.group.controls["Numbers"].setValue(this.customerOrder.group.controls["Numbers"].value);
    }
  }
}
